import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// 1. Ant Design
import { Alert, Card } from "antd";
// 2. External libraries
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
// 3. Internal components
import CompanyLinks from "@/components/CompanyLinks/CompanyLinks";
// 4. Stores
import { getRootStore } from "@/stores/RootStore";
// 5. Types, utils, styles
import { canManageCompanies } from "@/utils/permissions";
import styles from "@/styles/CompanyPage.module.less";
/**
 * Вкладка «Сотрудники» (P-5, UC1115): общий компонент привязок с API компании (`v_corp_links`, `corp_link_*`).
 * Компания в архиве — только просмотр (BR-CMP-07); у SUSPENDED привязки вести можно.
 */
const EmployeesTab = observer(() => {
    const { authStore, singleCompanyStore, companyLinksStore } = getRootStore();
    const company = singleCompanyStore.company;
    const companyId = company?.id ?? null;
    const readOnly = !company || company.status === "ARCHIVED" || !canManageCompanies(authStore.userRole);
    useEffect(() => {
        if (!companyId)
            return undefined;
        companyLinksStore.initForCompany(companyId, { readOnly });
        return () => companyLinksStore.dispose();
    }, [companyId]);
    useEffect(() => {
        companyLinksStore.setReadOnly(readOnly);
    }, [readOnly]);
    if (!company)
        return null;
    return (_jsxs(Card, { title: "\u0421\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438", className: styles.section, children: [company.status === "ARCHIVED" ? (_jsx(Alert, { type: "info", showIcon: true, className: styles.notice, message: "\u041A\u043E\u043C\u043F\u0430\u043D\u0438\u044F \u0432 \u0430\u0440\u0445\u0438\u0432\u0435 \u2014 \u043F\u0440\u0438\u0432\u044F\u0437\u043A\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430" })) : null, _jsx(CompanyLinks, { store: companyLinksStore, emptyText: "\u0421\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432 \u043F\u043E\u043A\u0430 \u043D\u0435\u0442 \u2014 \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u043F\u0435\u0440\u0432\u043E\u0433\u043E \u043F\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443" })] }));
});
EmployeesTab.displayName = "EmployeesTab";
export default EmployeesTab;
